import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 120px;

  .top {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 24px;
    align-items: end;
    margin-bottom: 34px;

    @media (max-width: 760px) {
      grid-template-columns: 1fr;
    }
  }

  .eyebrow {
    margin: 0 0 10px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 13px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .title {
    margin: 0;
    color: var(--text-primary);
    font-size: clamp(34px, 4.4vw, 54px);
    line-height: 1.06;
    letter-spacing: -0.04em;
  }

  .browse {
    color: var(--text-primary);
    text-decoration: none;
    font-family: var(--font-mono);
    font-size: 13px;
    border-bottom: 1px solid var(--border-medium);
    padding-bottom: 4px;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;

    @media (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }

  .card {
    padding: 26px;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.42);
    border: 1px solid rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    box-shadow:
      0 10px 30px rgba(0, 0, 0, 0.04),
      inset 0 1px 0 rgba(255, 255, 255, 0.35);
    min-height: 280px;
    transition: var(--transition);
  }

  .card:hover {
    transform: translateY(-2px);
    box-shadow:
      0 14px 34px rgba(0, 0, 0, 0.06),
      inset 0 1px 0 rgba(255, 255, 255, 0.42);
  }

  .type {
    margin: 0 0 12px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.14em;
  }

  .card h3 {
    margin: 0 0 14px;
    color: var(--text-primary);
    font-size: 28px;
    line-height: 1.12;
    letter-spacing: -0.03em;
  }

  .impact {
    margin: 0 0 12px;
    color: var(--text-primary);
    font-size: 16px;
    line-height: 1.75;
  }

  .body {
    color: var(--text-secondary);
    font-size: 15px;
    line-height: 1.8;
  }
`;

const FeaturedWork = () => {
  return (
    <StyledSection>
      <div className="top">
        <div>
          <p className="eyebrow">Selected Work</p>
          <h2 className="title">Breadth across software, analytics, and machine learning.</h2>
        </div>

        <Link className="browse" to="/projects">
          Browse all projects
        </Link>
      </div>

      <div className="grid">
        <div className="card">
          <p className="type">Healthcare / Analytics</p>
          <h3>Breast Cancer Dashboard</h3>
          <p className="impact">
            Designed an interactive analytical dashboard to surface meaningful patterns in clinical data.
          </p>
          <p className="body">
            Built to translate complex dataset exploration into clearer visual insight and decision support.
          </p>
        </div>

        <div className="card">
          <p className="type">Finance / Forecasting</p>
          <h3>NASDAQ Analysis</h3>
          <p className="impact">
            Combined exploratory analytics and forecasting methods to examine price movement and market behaviour.
          </p>
          <p className="body">
            A financial workflow spanning data analysis, dashboarding, and predictive interpretation.
          </p>
        </div>

        <div className="card">
          <p className="type">AI / Medical Imaging</p>
          <h3>VQA for Medical Images</h3>
          <p className="impact">
            Explored how image understanding and language reasoning can work together in healthcare settings.
          </p>
          <p className="body">
            A multimodal project connecting visual features and question answering for diagnostic support.
          </p>
        </div>
      </div>
    </StyledSection>
  );
};

export default FeaturedWork;